import { getPositions } from '@/data/position/selectors';
import type { WiwState } from '@/store';

import { createSelector } from '@reduxjs/toolkit';
import { Map } from 'immutable';

export const getJobDimensionId = (state: WiwState) => state.integrations.rippling.configuration.get('job_dimension_id');

export const getAccountJobDimensionId = (state: WiwState) =>
  state.integrations.rippling.configuration.get('account_job_dimension_id');

export const getAppListingId = (state: WiwState) => state.integrations.rippling.configuration.get('app_listing_id');

export const getMatchedPositions = (state: WiwState) =>
  state.integrations.rippling.configuration.get('positions').matched || Map();

export const getRipplingPositions = (state: WiwState) =>
  state.integrations.rippling.configuration.get('positions').rippling || Map();

export const getRipplingDimensions = (state: WiwState) =>
  state.integrations.rippling.configuration.get('positions').rippling_dimensions || Map();

export const getUnmatchedLocalPositions = createSelector(
  [getPositions, getMatchedPositions],
  (wiwPositions, matchedPositions) => {
    const matchedPositionIds = new Set();
    matchedPositions.keySeq().forEach(key => {
      matchedPositionIds.add(Number(key));
    });

    return wiwPositions.filter(position => {
      return !matchedPositionIds.has(position.id);
    });
  },
);
